module.exports = __webpack_public_path__ + "assets/img/carousel_school.2cc7bc8b.jpg";